import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.tsx';
import { PortalSettingsProvider } from '@l2u/ui/lib/portalSettings.tsx';
import { AdminAuthProvider } from './lib/auth/admin.tsx';
import { queryClient } from '@l2u/ui/lib/queryClient.ts';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element missing');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <PortalSettingsProvider>
        <BrowserRouter>
          <AdminAuthProvider>
            <App />
          </AdminAuthProvider>
        </BrowserRouter>
      </PortalSettingsProvider>
    </QueryClientProvider>
  </StrictMode>,
);
